<script setup>
  defineProps({
    index: { type: Number, required: true },
    message: { type: Object, required: true },
    isAutoGeneratedSummary: { type: Boolean, default: false },
  });
</script>

<template>
  <!-- The first "question" of an auto-generated summary thread is a synthetic
       prompt, so it stays hidden — only real user questions render as bubbles. -->
  <div
    v-if="!(index === 0 && isAutoGeneratedSummary)"
    :id="`assistant-message__question-item__${index}`"
    class="flex justify-end">
    <div class="max-w-[80%] whitespace-pre-wrap rounded-2xl bg-muted px-4 py-2.5 text-sm leading-snug">
      {{ message.question }}
    </div>
  </div>
</template>
